export default __webpack_public_path__ + "static/service-workshop-banner-2e0e5f3e3ac71d6b25a48d43f8c48322.png";